
import React, { useContext, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import AppContext from '../contexts/AppContext'

const Breadcrumbs = ({ list, children }) => {
    const isCancelled = React.useRef(false)
    const { location } = useContext(AppContext)

    const [ categoryClicked, setCategoryClicked ] = useState(null)

    const [ width, setWidth ] = useState(window.innerWidth)
    const updateDimensions = () => setWidth(window.innerWidth)
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    const isMobile = width >= 1200 ? false : true

    useEffect(() => {
        return () => { isCancelled.current = true}
    }, [])

    return (
        <nav aria-label="breadcrumb" className="d-print-none position-relative">
            <ol className="breadcrumb" itemScope itemType="https://schema.org/BreadcrumbList">
                {(!list || list.length == 0) &&
                    <li>&nbsp;</li>
                }
                {list && list.length > 0 && list.map((item, i) => {
                    if(item.external){
                        return (
                            <li
                                key={i}
                                className="breadcrumb-item"
                                itemProp="itemListElement" itemScope
                                itemType="https://schema.org/ListItem"
                            >
                                <a
                                    itemProp="item"
                                    href={item.url}
                                ><span itemProp="name">{item.title}</span></a>
                                <meta itemProp="position" content={i + 1} />
                            </li>
                        )
                    }else if(item.list) {
                        return (
                            <li className="breadcrumb-item dropdown" key={i}>
                                <a href={item.url} className="dropdown-toggle" data-bs-toggle="dropdown">
                                    {item.title} <b className="caret"></b>
                                </a>
                                {!categoryClicked &&
                                    <div className="dropdown-menu dropdown-3-column" style={{zIndex: 2000}}>
                                        {item.list.map(category =>
                                            <a
                                                key={category.id}
                                                className={'dropdown-item' + (item.id == category.id ? ' active' : '')}
                                                href={'/category/' + category.slug}
                                                onClick={() => {
                                                    setCategoryClicked(true)
                                                    setTimeout(() => {
                                                        if(!isCancelled.current){
                                                            setCategoryClicked(false)
                                                        }
                                                    }, 1)
                                                }}
                                            >{category.name}</a>
                                        )}
                                    </div>
                                }
                            </li>
                        )
                    }else if(item.url && (i + 1) < list.length) return (
                        <li
                            key={i}
                            className="breadcrumb-item"
                            itemProp="itemListElement" itemScope
                            itemType="https://schema.org/ListItem"
                        >
                            {item.tag == 'link' ? (
                                <Link
                                    to={item.url}
                                    tag="a"
                                    itemProp="item"
                                >
                                    <span itemProp="name">{item.title}</span>
                                </Link>
                            ) : (
                                <a
                                    href={item.url}
                                    itemProp="item"
                                >
                                    <span itemProp="name">{item.title}</span>
                                </a>
                            )}
                            <meta itemProp="position" content={i + 1} />
                        </li>
                    )
                    return <li key={i} className="breadcrumb-item active">{item.title}</li>
                })}
            </ol>
            {children}
        </nav>
    )
}

export default Breadcrumbs